import React from "react";

const ProgramerLanguage = () => {
    return(
        <div className="programer-language-container">
            <h3>Experience Programing Language</h3>
            <div className="borders space-around">
                <div className="borders">
                    <div className="border">HTML</div>
                    <div className="border">CSS</div>
                    <div className="border">Javascript</div>
                    <div className="border">Typescript</div>
                    <div className="border">Python</div>
                    <div className="border">R Programing</div>
                </div>
            </div>
        </div>
    )
}

export default ProgramerLanguage;